// LOAD ALL THE READ ONLY DATA
import { toast } from "react-toastify";
import { CARROCERIAS_PESADAS_API } from "../views/MainLayout/components/shared/services/carroceriasPesadas";
import {
  makeSetReducer,
} from "./utils";
import { setErrorMessage } from "../views/MainLayout/components/shared/helpers/functionalities";

export const carroceriasPesadasFullfilledReducer = makeSetReducer([
  "carrocerias_pesadas/fullfilled",
]);


export const fetchCarroceriasPesadas = () => async (dispatch) => {
  dispatch({ type: 'loading/set', payload: true })

  try {
    const response = await CARROCERIAS_PESADAS_API.get()
    const data = await response.data;
    dispatch({ type: "carrocerias_pesadas/fullfilled", payload: data });
    const readOnly = JSON.parse(localStorage.getItem('read_only'));
    readOnly.carrocerias_pesadas = data;
    localStorage.setItem('read_only', JSON.stringify(readOnly));
  } catch (e) {
    toast.error(setErrorMessage(e))
  } finally {
    dispatch({ type: 'loading/set', payload: false })
  }
};
